import InstagramFeed1 from "../../assets/upload/small_01.jpg"
import InstagramFeed2 from "../../assets/upload/small_02.jpg"
import InstagramFeed3 from "../../assets/upload/small_03.jpg"
import InstagramFeed4 from "../../assets/upload/small_04.jpg"
import InstagramFeed5 from "../../assets/upload/small_05.jpg"
import InstagramFeed6 from "../../assets/upload/small_06.jpg"
import InstagramFeed7 from "../../assets/upload/small_07.jpg"
import InstagramFeed8 from "../../assets/upload/small_08.jpg"
import InstagramFeed9 from "../../assets/upload/small_09.jpg"

const InstagramFeedData = [
    {
        id: 1,
        image: InstagramFeed1,
        srcLink: 'https://www.google.com'
    },
    {
        id: 2,
        image: InstagramFeed2,
        srcLink: 'https://www.google.com'
    },
    {
        id: 3,
        image: InstagramFeed3,
        srcLink: 'https://www.google.com'
    },
    {
        id: 4,
        image: InstagramFeed4,
        srcLink: 'https://www.google.com'
    },
    {
        id: 5,
        image: InstagramFeed5,
        srcLink: 'https://www.google.com'
    },
    {
        id: 6,
        image: InstagramFeed6,
        srcLink: 'https://www.google.com'
    },
    {
        id: 7,
        image: InstagramFeed7,
        srcLink: 'https://www.google.com'
    },
    {
        id: 8,
        image: InstagramFeed8,
        srcLink: 'https://www.google.com'
    },
    {
        id: 9,
        image: InstagramFeed9,
        srcLink: 'https://www.google.com'
    },
]

export default InstagramFeedData;